module.exports = __webpack_public_path__ + "img/chris_frieder_raichle.c18a7b89.webp";